module.exports = __webpack_public_path__ + "static/media/02.6233fb35.jpg";